import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M10.5,2 L13.5,2 C14.3284271,2 15,2.67157288 15,3.5 L15,22 L9,22 L9,3.5 C9,2.67157288 9.67157288,2 10.5,2 Z M11,4.0625 L11,20.5 L13,20.5 L13,4.0625 C13,3.47569745 12.5522847,3.4998578 12,3.4998578 C11.4477153,3.4998578 11,3.47569745 11,4.0625 Z M3.5,6 L6.5,6 C7.32842712,6 8,6.67157288 8,7.5 L8,22 L2,22 L2,7.5 C2,6.67157288 2.67157288,6 3.5,6 Z M4,8.08333333 L4,20.5 L6,20.5 L6,8.08333333 C6,7.48502485 5.55228475,7.49996597 5,7.49996597 C4.44771525,7.49996597 4,7.48502485 4,8.08333333 Z M17.5,12 L20.5,12 C21.3284271,12 22,12.6715729 22,13.5 L22,22 L16,22 L16,13.5 C16,12.6715729 16.6715729,12 17.5,12 Z M18,14.1666667 L18,20.5 L20,20.5 L20,14.1666667 C20,13.5223345 19.5522847,13.5 19,13.5 C18.4477153,13.5 18,13.5223345 18,14.1666667 Z"
      fill={fill}
    />
  </g>
);

export default Icon;
